/**
 *   Generated file. Do not edit
 */

import {
  ApduRequest,
  ApduResponse,
  TapRequestEncrypted,
  TapApduRequest,
  TapEncryptedFrame,
  TapRequestFrame,
  TapResponseFrame,
} from '@iotize/tap/client/api';
import {
  TapStreamReader,
  TapStreamWriter,
  enumKeyOrValueToNumber,
} from '../frame/tap-stream-core';

declare module '../frame/tap-stream-core' {
  export interface TapStreamReader {
    readApduRequest(): ApduRequest;

    readApduRequestHeader(): ApduRequest.Header;

    readApduResponse(): ApduResponse;

    readTapRequestEncrypted(): TapRequestEncrypted;

    readTapApduRequest(): TapApduRequest;

    readTapEncryptedFrame(): TapEncryptedFrame;

    readTapRequestFrame(): TapRequestFrame;

    readTapRequestFrameHeader(): TapRequestFrame.Header;

    readTapRequestFramePath(): TapRequestFrame.Path;

    readTapResponseFrame(): TapResponseFrame;
  }
  export interface TapStreamWriter {
    writeApduRequest(model: ApduRequest): TapStreamWriter;

    writeApduRequestHeader(model: ApduRequest.Header): TapStreamWriter;

    writeApduResponse(model: ApduResponse): TapStreamWriter;

    writeTapRequestEncrypted(model: TapRequestEncrypted): TapStreamWriter;

    writeTapApduRequest(model: TapApduRequest): TapStreamWriter;

    writeTapEncryptedFrame(model: TapEncryptedFrame): TapStreamWriter;

    writeTapRequestFrame(model: TapRequestFrame): TapStreamWriter;

    writeTapRequestFrameHeader(model: TapRequestFrame.Header): TapStreamWriter;

    writeTapRequestFramePath(model: TapRequestFrame.Path): TapStreamWriter;

    writeTapResponseFrame(model: TapResponseFrame): TapStreamWriter;
  }
}

TapStreamReader.prototype.readApduRequest = function (): ApduRequest {
  const model: Partial<ApduRequest> = {};

  model.header = this.readApduRequestHeader();

  model.data = this.readBytes(model.header.lc);

  return model as ApduRequest;
};

TapStreamReader.prototype.readApduRequestHeader =
  function (): ApduRequest.Header {
    const model: Partial<ApduRequest.Header> = {};

    model.cla = this.readUnsigned(1);

    model.ins = this.readUnsigned(1);

    model.p1 = this.readUnsigned(1);

    model.p2 = this.readUnsigned(1);

    model.lc = this.readUnsigned(1);

    return model as ApduRequest.Header;
  };

TapStreamReader.prototype.readApduResponse = function (): ApduResponse {
  const model: Partial<ApduResponse> = {};

  model.data = this.readBytes(this.getStreamSize() - 2);

  model.status = this.readUnsigned(2);

  return model as ApduResponse;
};

TapStreamReader.prototype.readTapRequestEncrypted =
  function (): TapRequestEncrypted {
    const model: Partial<TapRequestEncrypted> = {};

    model.header = this.readApduRequestHeader();

    model.request = this.readTapRequestFrame();

    return model as TapRequestEncrypted;
  };

TapStreamReader.prototype.readTapApduRequest = function (): TapApduRequest {
  const model: Partial<TapApduRequest> = {};

  return model as TapApduRequest;
};

TapStreamReader.prototype.readTapEncryptedFrame =
  function (): TapEncryptedFrame {
    const model: Partial<TapEncryptedFrame> = {};

    model.id = this.readUnsigned(2);

    model.len = this.readUnsigned(2);

    model.payload = this.readBytes(model.len);

    model.padding = this.readBytes(
      (16 - ((2 + 2 + (model.len === undefined ? 0 : model.len) + 4) % 16)) %
        16,
    );

    model.crc = this.readUnsigned(4);

    return model as TapEncryptedFrame;
  };

TapStreamReader.prototype.readTapRequestFrame = function (): TapRequestFrame {
  const model: Partial<TapRequestFrame> = {};

  model.header = this.readTapRequestFrameHeader();

  model.payload = this.readBytes();

  return model as TapRequestFrame;
};

TapStreamReader.prototype.readTapRequestFrameHeader =
  function (): TapRequestFrame.Header {
    const model: Partial<TapRequestFrame.Header> = {};

    model.methodType = this.readUnsigned(1);

    model.path = this.readTapRequestFramePath();

    return model as TapRequestFrame.Header;
  };

TapStreamReader.prototype.readTapRequestFramePath =
  function (): TapRequestFrame.Path {
    const model: Partial<TapRequestFrame.Path> = {};

    model.objectId = this.readUnsigned(2);

    model.objectInstanceId = this.readUnsigned(2);

    model.resourceId = this.readUnsigned(2);

    return model as TapRequestFrame.Path;
  };

TapStreamReader.prototype.readTapResponseFrame = function (): TapResponseFrame {
  const model: Partial<TapResponseFrame> = {};

  model.status = this.readUnsigned(1);

  model.data = this.readBytes();

  return model as TapResponseFrame;
};

// TapStreamWriter.prototype.write(model: ApduRequest) : TapStreamWriter{
//     return this.writeApduRequest(model)
// }

TapStreamWriter.prototype.writeApduRequest = function (
  model: ApduRequest,
): TapStreamWriter {
  this.writeApduRequestHeader(model.header);

  this.writeBytes(model.data, model.header.lc);

  return this;
};

TapStreamWriter.prototype.writeApduRequestHeader = function (
  model: ApduRequest.Header,
): TapStreamWriter {
  this.writeUnsigned(model.cla, 1);

  this.writeUnsigned(model.ins, 1);

  this.writeUnsigned(model.p1, 1);

  this.writeUnsigned(model.p2, 1);

  this.writeUnsigned(model.lc, 1);

  return this;
};

// TapStreamWriter.prototype.write(model: ApduResponse) : TapStreamWriter{
//     return this.writeApduResponse(model)
// }

TapStreamWriter.prototype.writeApduResponse = function (
  model: ApduResponse,
): TapStreamWriter {
  this.writeBytes(model.data, undefined);

  this.writeUnsigned(model.status, 2);

  return this;
};

// TapStreamWriter.prototype.write(model: TapRequestEncrypted) : TapStreamWriter{
//     return this.writeTapRequestEncrypted(model)
// }

TapStreamWriter.prototype.writeTapRequestEncrypted = function (
  model: TapRequestEncrypted,
): TapStreamWriter {
  this.writeApduRequestHeader(model.header);

  this.writeTapRequestFrame(model.request);

  return this;
};

// TapStreamWriter.prototype.write(model: TapApduRequest) : TapStreamWriter{
//     return this.writeTapApduRequest(model)
// }

TapStreamWriter.prototype.writeTapApduRequest = function (
  model: TapApduRequest,
): TapStreamWriter {
  return this;
};

// TapStreamWriter.prototype.write(model: TapEncryptedFrame) : TapStreamWriter{
//     return this.writeTapEncryptedFrame(model)
// }

TapStreamWriter.prototype.writeTapEncryptedFrame = function (
  model: TapEncryptedFrame,
): TapStreamWriter {
  this.writeUnsigned(model.id, 2);

  this.writeUnsigned(model.len, 2);

  this.writeBytes(model.payload, model.len);

  this.writeFunction(
    'padding',
    undefined,
    model.padding,
    (16 - ((2 + 2 + (model.len === undefined ? 0 : model.len) + 4) % 16)) % 16,
  );

  this.writeFunction('crc32', undefined, model.crc, 4);

  return this;
};

// TapStreamWriter.prototype.write(model: TapRequestFrame) : TapStreamWriter{
//     return this.writeTapRequestFrame(model)
// }

TapStreamWriter.prototype.writeTapRequestFrame = function (
  model: TapRequestFrame,
): TapStreamWriter {
  this.writeTapRequestFrameHeader(model.header);

  this.writeBytes(model.payload);

  return this;
};

TapStreamWriter.prototype.writeTapRequestFrameHeader = function (
  model: TapRequestFrame.Header,
): TapStreamWriter {
  this.writeBitsInt(
    enumKeyOrValueToNumber<TapRequestFrame.MethodType>(
      model.methodType,
      TapRequestFrame.MethodType,
    ),
    8,
  );

  this.writeTapRequestFramePath(model.path);

  return this;
};

TapStreamWriter.prototype.writeTapRequestFramePath = function (
  model: TapRequestFrame.Path,
): TapStreamWriter {
  this.writeUnsigned(model.objectId, 2);

  this.writeUnsigned(model.objectInstanceId, 2);

  this.writeUnsigned(model.resourceId, 2);

  return this;
};

// TapStreamWriter.prototype.write(model: TapResponseFrame) : TapStreamWriter{
//     return this.writeTapResponseFrame(model)
// }

TapStreamWriter.prototype.writeTapResponseFrame = function (
  model: TapResponseFrame,
): TapStreamWriter {
  this.writeUnsigned(model.status, 1);

  this.writeBytes(model.data);

  return this;
};
